import { cn } from '@/utils/cn';
import { useCustomerUsers } from '@/utils/use-customer-users';
import { Skeleton } from '@bits/ui';

import { LetterAvatar } from '@/components/letter-avatar';
import { extractInitials } from '@/components/letter-avatar/letter-avatar';

type UserDisplayerProps = {
  userId?: string | null;
  className?: string;
};

export const UserDisplayer = ({ userId, className }: UserDisplayerProps) => {
  const { data: { users } = {}, isLoading } = useCustomerUsers();

  if (isLoading) {
    return (
      <div className={cn('inline-flex items-center gap-2', className)}>
        <Skeleton className="size-6 rounded-full" />
        <Skeleton className="h-6 w-[180px]" />
      </div>
    );
  }

  const assignee = users?.find((user) => user.id === userId);

  const fullName = assignee ? `${assignee.firstName} ${assignee.lastName}` : '';

  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      <LetterAvatar className="size-7" initials={extractInitials(fullName)} />

      {fullName}
    </div>
  );
};
